import { render } from "./CodeTags.vue?vue&type=template&id=bae8ebbc"
import script from "./CodeTags.vue?vue&type=script&lang=js"
export * from "./CodeTags.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CodeTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bae8ebbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bae8ebbc', __exports__)) {
    api.reload('bae8ebbc', __exports__)
  }
  
  module.hot.accept("./CodeTags.vue?vue&type=template&id=bae8ebbc", () => {
    api.rerender('bae8ebbc', render)
  })

}


export default __exports__